function setServerGlobals() {
  process.env.VXRN_REACT_19 = "1";
  process.env.VITE_ENVIRONMENT = "ssr";
  globalThis["requestAnimationFrame"] = setTimeout;
}
export {
  setServerGlobals
};
//# sourceMappingURL=setServerGlobals.js.map
